import type { GlobalSearchParams } from '@/modules/search/types';

export const searchQueryKeys = {
    all:   ['search'] as const,
    query: (params: GlobalSearchParams) => [...searchQueryKeys.all, params] as const,
} as const;
